import React, { Fragment, useEffect } from 'react';
import { APP_STORAGE_KEY } from '../../../../constants';
import { signIn, isInAuthCallback } from 'app/app-auth';
import { Spinner } from 'app/components/shared/spinner/spinner';

export function Login() {
	// In different browsers like safari we do have appCode in sessionStorage when dialog opens so first we check localStorage and fallback to sessionStorage
	const code = localStorage.getItem( APP_STORAGE_KEY ) || sessionStorage.getItem( APP_STORAGE_KEY );
	useEffect( () => {
		const handleSignIn = async () => {
			const user = await signIn( code ) ;
			// eslint-disable-next-line no-undef
			Office.context.ui.messageParent( JSON.stringify( user ) );
		};
		if ( !isInAuthCallback( code ) ) {
			handleSignIn();
		}
	}, [] );

	return (
		<Fragment>
			<Spinner loading={ true }/>
		</Fragment>
	);
}
